module.exports = {"152528100":"新宝拉格镇","152528101":"巴彦塔拉镇","152528200":"翁贡乌拉苏木","152528201":"宝格达音髙勒苏木"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152528.json
// module id = 579
// module chunks = 0